const initialState = {
    bookingsData: [],
    loading: false,
  };
  
  const bookingsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_BOOKINGS_DATA':
        return {
          ...state,
          bookingsData: action.payload,
        };
      case 'SET_LOADING':
        return {
          ...state,
          loading: action.payload,
        };
      case 'UPDATE_BOOKING_STATUS':
        return {
          ...state,
          bookingsData: state.bookingsData.map((booking) =>
            booking._id === action.payload.id
              ? { ...booking, bookingStatus: action.payload.status }
              : booking
          ),
        };
      default:
        return state;
    }
  };
  
  export default bookingsReducer;
  